import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Hero } from "@/components/home/Hero";
import { TrustBar } from "@/components/home/TrustBar";
import { ProblemSolution } from "@/components/home/ProblemSolution";
import { ServicePillars } from "@/components/home/ServicePillars";
import { Lifecycle } from "@/components/home/Lifecycle";
import { MarketIntelligence } from "@/components/home/MarketIntelligence";
import { StatsGrid } from "@/components/home/StatsGrid";
import { Testimonials } from "@/components/home/Testimonials";
import { FeaturedCaseStudies } from "@/components/home/FeaturedCaseStudies";
import { ToolsPreview } from "@/components/home/ToolsPreview";
import { FinalCTA } from "@/components/home/FinalCTA";

export default function Home() {
  const [stats, setStats] = useState([]);
  const [counters, setCounters] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [caseStudies, setCaseStudies] = useState([]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const [s, t, c] = await Promise.all([
          api.getStats().catch(() => ({ stats: [], counters: [] })),
          api.getTestimonials().catch(() => []),
          api.getCaseStudies().catch(() => []),
        ]);
        if (!mounted) return;
        setStats(s.stats || []);
        setCounters(s.counters || []);
        setTestimonials(t || []);
        setCaseStudies(c || []);
      } catch (e) {
        /* graceful */
      }
    })();
    return () => { mounted = false; };
  }, []);

  return (
    <>
      <Hero />
      <TrustBar />
      <ProblemSolution />
      <ServicePillars />
      <Lifecycle />
      <MarketIntelligence counters={counters} />
      <StatsGrid stats={stats} />
      <Testimonials testimonials={testimonials} />
      <FeaturedCaseStudies caseStudies={caseStudies} />
      <ToolsPreview />
      <FinalCTA />
    </>
  );
}
